import { render, staticRenderFns } from "./CrftAdd.vue?vue&type=template&id=01c2fa3a&scoped=true&"
import script from "./CrftAdd.vue?vue&type=script&lang=js&"
export * from "./CrftAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2fa3a",
  null
  
)

export default component.exports